// src/views/ContratoForm.jsx
import React, { useEffect, useMemo, useState } from "react";
import { createContrato, updateContrato, getContratos } from "../services/api";
import { useNavigate, useParams } from "react-router-dom";


import {
  useInventarioCatalogos,
} from "../hooks/useInventarioCatalogos";


const TIPO_TELEFONIA = "TELEFONIA_INTERNET";
const TIPO_SUSCRIPCION = "SUSCRIPCION_DIGITAL";

const COMPANIAS_TELEFONIA = ["Telmex", "Totalplay", "Starlink"];

const COMPANIAS_SUSCRIPCIONES = [
  "AWS",
  "AnyDesk",
  "Google Workspace",
  "Apple Developer",
  "ChatGPT",
  "Claude",
  "Canva",
  "Adobe",
  "Microsoft 365",
  "Antivirus",
  "NordVPN",
  "Dropbox",
  "GitHub",
  "Otro",
];

const PERIODICIDADES = [
  { value: "mensual", label: "Mensual" },
  { value: "trimestral", label: "Trimestral" },
  { value: "semestral", label: "Semestral" },
  { value: "anual", label: "Anual" },
  { value: "unico", label: "Pago único" },
];

const ESTATUS = ["ACTIVO", "POR_RENOVAR", "SUSPENDIDO", "CANCELADO"];

export default function ContratoForm() {

  // CONTRATOFORM_MUNICIPIOS_DINAMICOS_V1
  const {
    municipios: catalogoMunicipios,
  
    getOficinasByMunicipioNombre,
  } = useInventarioCatalogos();


  const navigate = useNavigate();
  const { id } = useParams();

  const [loadingEdit, setLoadingEdit] = useState(false);

  const formatPhone = (value) => {
    if (!value) return "";
    const digits = value.replace(/\D/g, "").slice(0, 10);
    const p1 = digits.slice(0, 3);
    const p2 = digits.slice(3, 6);
    const p3 = digits.slice(6, 10);

    if (digits.length <= 3) return `(${p1}`;
    if (digits.length <= 6) return `(${p1}) ${p2}`;
    return `(${p1}) ${p2}-${p3}`;
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const raw = String(value);

    if (raw.includes("$")) {
      const digits = raw.replace(/[^\d]/g, "");
      if (!digits) return "";
      const number = Number(digits) / 100;
      return number.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    }

    const number = Number(raw);
    if (!Number.isNaN(number) && raw.indexOf(".") >= 0) {
      return number.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    }

    const digits = raw.replace(/[^\d]/g, "");
    if (!digits) return "";
    const amount = Number(digits) / 100;

    return amount.toLocaleString("es-MX", {
      style: "currency",
      currency: "MXN",
    });
  };

  const limpiarTelefono = (t = "") => String(t).replace(/\D/g, "");

  const limpiarMonto = (m) => {
    if (m === null || m === undefined || m === "") return null;

    if (typeof m === "number") {
      return Number.isFinite(m) ? m : null;
    }

    const raw = String(m);

    if (!raw.includes("$") && raw.includes(".")) {
      const n = Number(raw.replace(/,/g, ""));
      return Number.isNaN(n) ? null : n;
    }

    const digits = raw.replace(/[^\d]/g, "");
    if (!digits) return null;

    return Number(digits) / 100;
  };

  const [form, setForm] = useState({
    tipoServicio: TIPO_TELEFONIA,

    compania: "",
    ubicacion: "",
    oficina: "",
    propietario: "",
    correo: "",
    telefono: "",
    fechaPago: "",
    totalPagar: "",
    numeroCuenta: "",
    contrasena: "",

    proveedor: "",
    servicio: "",
    plan: "",
    periodicidad: "mensual",
    fechaInicio: "",
    fechaRenovacion: "",
    responsableInterno: "",
    correoAdministrador: "",
    usuariosContratados: "",
    metodoPago: "",
    estatus: "ACTIVO",
    notas: "",
  });

  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = "success") => {
    const toastId = Date.now();
    setToasts((prev) => [...prev, { id: toastId, message, type }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== toastId));
    }, 3500);
  };

  const cerrarToast = (toastId) => {
    setToasts((prev) => prev.filter((t) => t.id !== toastId));
  };

  const mostrarCampos = {
    Telmex: ["ubicacion", "propietario", "oficina", "correo", "telefono", "totalPagar"],
    Totalplay: [
      "ubicacion",
      "propietario",
      "oficina",
      "numeroCuenta",
      "contrasena",
      "totalPagar",
    ],
    Starlink: ["ubicacion", "propietario", "oficina", "correo", "totalPagar"],
  };

  const camposVisibles = mostrarCampos[form.compania] || [];

  
  // CONTRATOFORM_OFICINAS_DINAMICAS_V1
  const oficinasDisponibles = 
(getOficinasByMunicipioNombre(form.ubicacion) || [])
  .map((oficina) => oficina.nombre)
;

  const companiasDisponibles = useMemo(() => {
    return form.tipoServicio === TIPO_SUSCRIPCION
      ? COMPANIAS_SUSCRIPCIONES
      : COMPANIAS_TELEFONIA;
  }, [form.tipoServicio]);

  useEffect(() => {
    const cargarParaEditar = async () => {
      if (!id) return;

      setLoadingEdit(true);

      try {
        const res = await getContratos();
        const lista = Array.isArray(res.data) ? res.data : [];
        const actual = lista.find((x) => String(x.id) === String(id));

        if (!actual) {
          showToast("No se encontró el contrato para editar", "error");
          return;
        }

        setForm((prev) => ({
          ...prev,
          tipoServicio: actual.tipoServicio || TIPO_TELEFONIA,

          compania: actual.compania || "",
          ubicacion: actual.ubicacion || "",
          oficina: actual.oficina || "",
          propietario: actual.propietario || "",
          correo: actual.correo || "",
          telefono: actual.telefono ? formatPhone(String(actual.telefono)) : "",
          fechaPago: actual.fechaPago || "",
          totalPagar:
            actual.totalPagar !== null && actual.totalPagar !== undefined
              ? formatCurrency(String(actual.totalPagar))
              : "",
          numeroCuenta: actual.numeroCuenta || "",
          contrasena: actual.contrasena || "",

          proveedor: actual.proveedor || "",
          servicio: actual.servicio || actual.plataforma || "",
          plan: actual.plan || "",
          periodicidad: actual.periodicidad || "mensual",
          fechaInicio: actual.fechaInicio || "",
          fechaRenovacion: actual.fechaRenovacion || "",
          responsableInterno: actual.responsableInterno || actual.propietario || "",
          correoAdministrador: actual.correoAdministrador || actual.correo || "",
          usuariosContratados: actual.usuariosContratados || "",
          metodoPago: actual.metodoPago || "",
          estatus: actual.estatus || "ACTIVO",
          notas: actual.notas || "",
        }));
      } catch (err) {
        console.error("Error al cargar contrato:", err);
        showToast("Error al cargar contrato", "error");
      } finally {
        setLoadingEdit(false);
      }
    };

    cargarParaEditar();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "tipoServicio") {
      setForm((prev) => ({
        ...prev,
        tipoServicio: value,
        compania: "",
        ubicacion: "",
        oficina: "",
        propietario: "",
        correo: "",
        telefono: "",
        fechaPago: "",
        totalPagar: "",
        numeroCuenta: "",
        contrasena: "",
        proveedor: "",
        servicio: "",
        plan: "",
        periodicidad: "mensual",
        fechaInicio: "",
        fechaRenovacion: "",
        responsableInterno: "",
        correoAdministrador: "",
        usuariosContratados: "",
        metodoPago: "",
        estatus: "ACTIVO",
        notas: "",
      }));
      return;
    }

    if (name === "compania") {
      setForm((prev) => ({
        ...prev,
        compania: value,
        proveedor: value,
      }));
      return;
    }

    

    // CONTRATOFORM_RESET_OFICINA_AL_CAMBIAR_MUNICIPIO_V1
    if (name === "ubicacion") {
      setForm((prev) => ({
        ...prev,
        ubicacion: value,
        oficina: "",
      }));
      return;
    }

setForm((prev) => ({ ...prev, [name]: value }));
  };

  const guardar = async () => {
    try {
      if (!form.tipoServicio) {
        return showToast("Seleccione el tipo de servicio", "error");
      }

      if (!form.compania) {
        return showToast("Seleccione una compañía o plataforma", "error");
      }

      const monto = limpiarMonto(form.totalPagar);

      if (monto === null || monto <= 0) {
        return showToast("Capture un costo válido", "error");
      }

      let payload = {
        tipoServicio: form.tipoServicio,
        compania: form.compania,
        totalPagar: monto,
        fechaPago: form.fechaPago || "",
        periodicidad: form.periodicidad || "mensual",
        estatus: form.estatus || "ACTIVO",
      };

      if (form.tipoServicio === TIPO_TELEFONIA) {
        if (!form.ubicacion) {
          return showToast("Seleccione una ubicación", "error");
        }

        camposVisibles.forEach((campo) => {
          if (campo === "telefono") {
            payload.telefono = limpiarTelefono(form.telefono);
          } else if (campo === "totalPagar") {
            payload.totalPagar = monto;
          } else {
            payload[campo] = form[campo] || "";
          }
        });

        payload.proveedor = form.compania;
        payload.servicio = "Telefonía / Internet";
        payload.plan = form.plan || "";
        payload.fechaInicio = form.fechaInicio || "";
        payload.fechaRenovacion = form.fechaRenovacion || "";
        payload.responsableInterno = form.propietario || "";
        payload.correoAdministrador = form.correo || "";
        payload.usuariosContratados = "";
        payload.metodoPago = form.metodoPago || "";
        payload.notas = form.notas || "";
      }

      if (form.tipoServicio === TIPO_SUSCRIPCION) {
        if (!form.servicio) {
          return showToast("Capture el servicio o plataforma", "error");
        }

        if (!form.periodicidad) {
          return showToast("Seleccione la periodicidad", "error");
        }

        payload = {
          ...payload,
          proveedor: form.proveedor || form.compania,
          servicio: form.servicio,
          plataforma: form.servicio,
          plan: form.plan || "",
          fechaInicio: form.fechaInicio || "",
          fechaRenovacion: form.fechaRenovacion || "",
          responsableInterno: form.responsableInterno || "",
          correoAdministrador: form.correoAdministrador || "",
          usuariosContratados: form.usuariosContratados
            ? Number(form.usuariosContratados)
            : "",
          metodoPago: form.metodoPago || "",
          notas: form.notas || "",

          ubicacion: form.ubicacion || "Corporativo",
          oficina: form.oficina || "Administración central",
          propietario: form.responsableInterno || "IP DEPOT",
          correo: form.correoAdministrador || "",
          telefono: "",
          numeroCuenta: form.numeroCuenta || "",
          contrasena: form.contrasena || "",
        };
      }

      if (id) {
        await updateContrato(id, payload);
        showToast("Servicio actualizado correctamente", "success");
      } else {
        await createContrato(payload);
        showToast("Servicio guardado correctamente", "success");
      }

      setTimeout(() => navigate("/contratos"), 900);
    } catch (err) {
      console.error("❌ Error al guardar servicio:", err);
      showToast("Error al guardar servicio", "error");
    }
  };

  const esSuscripcion = form.tipoServicio === TIPO_SUSCRIPCION;
  const esTelefonia = form.tipoServicio === TIPO_TELEFONIA;

  return (
    <>
      <div className="fixed top-4 right-4 z-50 space-y-3">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`px-4 py-3 rounded-xl shadow-lg text-white flex justify-between gap-4 ${
              t.type === "success" ? "bg-green-600" : "bg-red-600"
            }`}
            style={{ minWidth: 260 }}
          >
            <span>{t.message}</span>
            <button onClick={() => cerrarToast(t.id)}>×</button>
          </div>
        ))}
      </div>

      <div className="p-8 max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          {id ? "Editar Servicio" : "Agregar Servicio"}
        </h1>

        <p className="text-gray-500 mb-6">
          Captura contratos de telefonía, internet y suscripciones digitales.
        </p>

        {loadingEdit && (
          <div className="mb-4 rounded-xl border border-blue-200 bg-blue-50 p-4 text-blue-700">
            Cargando información del servicio...
          </div>
        )}

        <div className="bg-white p-6 rounded-xl shadow-sm border mb-6">
          <label className="font-semibold text-sm">Tipo de servicio *</label>

          <select
            name="tipoServicio"
            value={form.tipoServicio}
            onChange={handleChange}
            className="w-full mt-2 p-2 border rounded-lg bg-gray-50"
          >
            <option value={TIPO_TELEFONIA}>Telefonía / Internet</option>
            <option value={TIPO_SUSCRIPCION}>Suscripción digital</option>
          </select>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border mb-6">
          <label className="font-semibold text-sm">
            {esSuscripcion ? "Plataforma / Servicio *" : "Compañía *"}
          </label>

          <select
            name="compania"
            value={form.compania}
            onChange={handleChange}
            className="w-full mt-2 p-2 border rounded-lg bg-gray-50"
          >
            <option value="">
              {esSuscripcion ? "Seleccione plataforma" : "Seleccione compañía"}
            </option>

            {companiasDisponibles.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        {form.compania && esTelefonia && (
          <>
            <div className="bg-white p-6 rounded-xl shadow-sm border mb-6">
              <h2 className="text-lg font-semibold mb-3">Datos generales</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {camposVisibles.includes("ubicacion") && (
                  <div>
                    <label className="text-sm font-medium">Ubicación *</label>
                    <select
                      name="ubicacion"
                      value={form.ubicacion}
                      onChange={handleChange}
                      className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                    >

                      <option value="">
                        Seleccione municipio
                      </option>

                      {catalogoMunicipios.map((municipio) => (
                        <option
                          key={municipio.id}
                          value={municipio.nombre}
                        >
                          {municipio.nombre}
                        </option>
                      ))}

                    </select>
                  </div>
                )}

                {camposVisibles.includes("oficina") && (
                  <div>
                    <label className="text-sm font-medium">Oficina *</label>
                    <select
                      name="oficina"
                      value={form.oficina}
                      onChange={handleChange}
                      disabled={!form.ubicacion}
                      className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                    >
                      <option value="">Seleccione oficina</option>
                      {oficinasDisponibles.map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {camposVisibles.includes("propietario") && (
                  <div>
                    <label className="text-sm font-medium">Propietario *</label>
                    <input
                      name="propietario"
                      value={form.propietario}
                      onChange={handleChange}
                      className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                    />
                  </div>
                )}

                {camposVisibles.includes("correo") && (
                  <div>
                    <label className="text-sm font-medium">Correo</label>
                    <input
                      type="email"
                      name="correo"
                      value={form.correo}
                      onChange={handleChange}
                      className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                    />
                  </div>
                )}

                {camposVisibles.includes("telefono") && (
                  <div>
                    <label className="text-sm font-medium">Teléfono</label>
                    <input
                      name="telefono"
                      value={form.telefono}
                      onChange={(e) =>
                        setForm({ ...form, telefono: formatPhone(e.target.value) })
                      }
                      maxLength={16}
                      placeholder="(999) 999-9999"
                      className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                    />
                  </div>
                )}

                <div>
                  <label className="text-sm font-medium">Método de pago</label>
                  <input
                    name="metodoPago"
                    value={form.metodoPago}
                    onChange={handleChange}
                    placeholder="Tarjeta, transferencia, domiciliado..."
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border mb-6">
              <h2 className="text-lg font-semibold mb-3">Detalles del contrato</h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="text-sm font-medium">Total a pagar *</label>
                  <input
                    name="totalPagar"
                    value={form.totalPagar}
                    onChange={(e) =>
                      setForm({ ...form, totalPagar: formatCurrency(e.target.value) })
                    }
                    placeholder="$0.00"
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50 text-right"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Periodicidad</label>
                  <select
                    name="periodicidad"
                    value={form.periodicidad}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  >
                    {PERIODICIDADES.map((p) => (
                      <option key={p.value} value={p.value}>
                        {p.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="text-sm font-medium">Fecha de pago</label>
                  <input
                    type="date"
                    name="fechaPago"
                    value={form.fechaPago}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Fecha de renovación</label>
                  <input
                    type="date"
                    name="fechaRenovacion"
                    value={form.fechaRenovacion}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Estatus</label>
                  <select
                    name="estatus"
                    value={form.estatus}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  >
                    {ESTATUS.map((e) => (
                      <option key={e} value={e}>
                        {e}
                      </option>
                    ))}
                  </select>
                </div>

                {camposVisibles.includes("numeroCuenta") && (
                  <div>
                    <label className="text-sm font-medium">Número de cuenta</label>
                    <input
                      name="numeroCuenta"
                      value={form.numeroCuenta}
                      onChange={handleChange}
                      className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                    />
                  </div>
                )}

                {camposVisibles.includes("contrasena") && (
                  <div>
                    <label className="text-sm font-medium">Contraseña</label>
                    <input
                      name="contrasena"
                      value={form.contrasena}
                      onChange={handleChange}
                      className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                    />
                  </div>
                )}
              </div>

              <div className="mt-4">
                <label className="text-sm font-medium">Notas</label>
                <textarea
                  name="notas"
                  value={form.notas}
                  onChange={handleChange}
                  rows={3}
                  className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                />
              </div>
            </div>
          </>
        )}

        {form.compania && esSuscripcion && (
          <>
            <div className="bg-white p-6 rounded-xl shadow-sm border mb-6">
              <h2 className="text-lg font-semibold mb-3">Datos de la suscripción</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium">Proveedor</label>
                  <input
                    name="proveedor"
                    value={form.proveedor}
                    onChange={handleChange}
                    placeholder="Ej. Amazon Web Services"
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Servicio / Plataforma *</label>
                  <input
                    name="servicio"
                    value={form.servicio}
                    onChange={handleChange}
                    placeholder="Ej. Cuenta AWS Producción"
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Plan</label>
                  <input
                    name="plan"
                    value={form.plan}
                    onChange={handleChange}
                    placeholder="Ej. Business, Team, Pro, pago por consumo"
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Costo *</label>
                  <input
                    name="totalPagar"
                    value={form.totalPagar}
                    onChange={(e) =>
                      setForm({ ...form, totalPagar: formatCurrency(e.target.value) })
                    }
                    placeholder="$0.00"
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50 text-right"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Periodicidad *</label>
                  <select
                    name="periodicidad"
                    value={form.periodicidad}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  >
                    {PERIODICIDADES.map((p) => (
                      <option key={p.value} value={p.value}>
                        {p.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="text-sm font-medium">Estatus</label>
                  <select
                    name="estatus"
                    value={form.estatus}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  >
                    {ESTATUS.map((e) => (
                      <option key={e} value={e}>
                        {e}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="text-sm font-medium">Fecha de inicio</label>
                  <input
                    type="date"
                    name="fechaInicio"
                    value={form.fechaInicio}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Fecha de renovación</label>
                  <input
                    type="date"
                    name="fechaRenovacion"
                    value={form.fechaRenovacion}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Responsable interno</label>
                  <input
                    name="responsableInterno"
                    value={form.responsableInterno}
                    onChange={handleChange}
                    placeholder="Ej. Sistemas, Administración, Dirección"
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Correo administrador</label>
                  <input
                    type="email"
                    name="correoAdministrador"
                    value={form.correoAdministrador}
                    onChange={handleChange}
                    placeholder="admin@empresa.com"
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Usuarios contratados</label>
                  <input
                    type="number"
                    min="0"
                    name="usuariosContratados"
                    value={form.usuariosContratados}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Método de pago</label>
                  <input
                    name="metodoPago"
                    value={form.metodoPago}
                    onChange={handleChange}
                    placeholder="Tarjeta corporativa, transferencia, PayPal..."
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Número de cuenta / ID cliente</label>
                  <input
                    name="numeroCuenta"
                    value={form.numeroCuenta}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium">Contraseña / referencia segura</label>
                  <input
                    name="contrasena"
                    value={form.contrasena}
                    onChange={handleChange}
                    className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                  />
                </div>
              </div>

              <div className="mt-4">
                <label className="text-sm font-medium">Notas</label>
                <textarea
                  name="notas"
                  value={form.notas}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Ej. Cuenta usada para infraestructura, desarrollo, diseño, soporte remoto..."
                  className="w-full mt-1 p-2 border rounded-lg bg-gray-50"
                />
              </div>
            </div>
          </>
        )}

        <div className="flex gap-4 justify-end">
          <button
            className="px-6 py-2 rounded-xl bg-gray-300"
            onClick={() => navigate("/contratos")}
          >
            Cancelar
          </button>

          <button
            type="button"
            onClick={guardar}
            className="px-6 py-2 rounded-xl bg-blue-600 text-white font-semibold"
          >
            {id ? "Actualizar servicio" : "Guardar servicio"}
          </button>
        </div>
      </div>
    </>
  );
}